import { finishEvent, SimplePool } from "../nostric-tools";
import { Actor, HttpAgent } from "@dfinity/agent";
import { NDKKind } from "@nostr-dev-kit/ndk";
import { createActor, idlFactory } from "./relay_declarations";
import { nostric_events, nostric_relays_count, nostric_relays_eose_count, relay_statuses, STATUS } from "../store/nostric";
import { auth_client, nostric_service } from "../store/auth";
import { alert } from "../store/alert";
export class NostricHandler {
    constructor() {
        this.private_relay_canister_actor = null;
        this.private_relay_set = false;
        this.relay_pool = null;
        this.active_subs = null;
        this.active_relays = [];
        this.eose_number = 0;
        this.expected_eose_number = 0;
    }
    init(private_key, public_key, ic_url, local, persist_key) {
        this.private_key = private_key;
        this.public_key = public_key;
        this.ic_url = ic_url;
        this.local = local;
        this.persist_key = persist_key;
    }
    get_private_key() {
        return this.private_key;
    }
    get_gateway_url() {
        return this.gateway_url;
    }
    get_private_relay_canister_id() {
        return this.private_relay_canister_id;
    }
    async init_private_relay(gateway_url, private_relay_canister_id) {
        this.gateway_url = gateway_url;
        this.private_relay_canister_id = private_relay_canister_id;
        let options = {
            agentOptions: {
                host: this.ic_url,
                identity: auth_client.getIdentity(),
            }
        };
        this.private_relay_canister_actor = await createActor(this.private_relay_canister_id, options);
        this.private_relay_set = true;
    }
    async init_foreign_relay(gateway_url, canister_id) {
        // init the agent for the foreign relay using the universal candid of relays
        // the private relay does not have to be activated
        const agent = new HttpAgent({ host: this.ic_url });
        if (process.env.DFX_NETWORK !== "ic") {
            await agent.fetchRootKey();
        }
        const actor = await Actor.createActor(idlFactory, {
            agent,
            canisterId: canister_id,
        });
        return {
            gateway_url,
            ic_url: this.ic_url,
            canister_id,
            canister_actor: actor,
            local: this.local,
            persist_key: this.persist_key
        };
    }
    get_private_relay_params() {
        if (this.private_relay_canister_actor)
            return {
                gateway_url: this.gateway_url,
                ic_url: this.ic_url,
                canister_id: this.private_relay_canister_id,
                canister_actor: this.private_relay_canister_actor,
                local: this.local,
                persist_key: this.persist_key
            };
        else {
            return null;
        }
    }
    close_pool() {
        nostric_events.clear();
        if (this.active_subs !== null) {
            this.active_subs.unsub();
        }
        if (this.relay_pool !== null) {
            this.relay_pool.close(this.active_relays);
        }
    }
    async init_pool(relays) {
        // init foreign relays if any
        if (relays.length > 0) {
            for (let nostric_relay of relays) {
                if (nostric_relay.gateway_url !== this.gateway_url ||
                    nostric_relay.canister_id !== this.private_relay_canister_id) {
                    let foreign_relay = await nostric_service.init_foreign_relay(nostric_relay.gateway_url, nostric_relay.canister_id);
                    this.active_relays.push(foreign_relay);
                }
            }
        }
        if (this.private_relay_set) {
            this.active_relays.push(this.get_private_relay_params());
        }
        if (this.active_relays.length > 0) {
            nostric_relays_count.set(this.active_relays.length);
            this.relay_pool = new SimplePool();
            this.active_subs = this.relay_pool.sub(this.active_relays, []);
            this.active_subs.on("event", (event) => {
                nostric_events.add(event);
            });
            this.active_subs.on("eose", () => {
                nostric_relays_eose_count.update((previous) => previous + 1);
            });
            this.active_subs.on("error", (error) => {
                relay_statuses.set_status(error.gateway_url, error.canister_id, STATUS.ERROR);
                alert.error(`Refresh the app! Error in connection to gateway ${error.gateway_url} with ID ${error.canister_id}. Is the address correct?`);
            });
        }
    }
    async get_number_of_subscriptions() {
        return await this.private_relay_canister_actor.get_number_of_active_subscriptions();
    }
    async publish_to_private_relay(content) {
        if (this.private_relay_canister_actor) {
            let event = {
                kind: NDKKind.Text,
                created_at: Math.floor(Date.now() / 1000),
                tags: [],
                content,
                pubkey: this.public_key,
            };
            const signed_event = finishEvent(event, this.private_key);
            await this.private_relay_canister_actor.add_new_event(signed_event);
            return signed_event;
        }
        else {
            console.error("Private relay actor not set");
        }
    }
}
